import Styled from './styled'
import { useStoreActions, useStoreState } from 'easy-peasy'
import _ from 'lodash'
import { useCallback, useState } from 'react'
import { useTranslate } from 'hooks/translate'
import { Typography, Spin, Empty } from 'antd'
import { useAsync } from 'react-use'
const RiskMatrixChart = ({ onChange, loading, dataSource, defaultValue, impactTypeId }) => {
  const { t } = useTranslate()

  const { reportMatrixValue } = useStoreState((store) => store.monthlyDashboard)
  const { getReportMatrixValueThunk } = useStoreActions((store) => store.monthlyDashboard)
  useAsync(async () => {
    // Add get default matrix
    if (impactTypeId) {
      getReportMatrixValueThunk(impactTypeId)
    }
  }, [impactTypeId])

  const [selected, setSelected] = useState()
  const row = useCallback(
    ({ data, onClick }) => {
      const table = []
      let temp = undefined
      let children = []
      const likelihoodLabel = []
      const riskLabel = []
      const length = reportMatrixValue.length
      let count = 0
      
      _.orderBy(reportMatrixValue,['likelihood_score','impact_score'],'desc').map((item, index) => {
        const addToRow = () => {
          count++
          table.push(<tr key={index}>{children}</tr>)
          children = []
        }
        // Add Label Row
        if (!likelihoodLabel.includes(item.likelihood)) {
          likelihoodLabel.push(item.likelihood)
        }
        // Add Label Column
        if (!riskLabel.includes(item.impact)) {
          riskLabel.push(item.impact)
        }

        // Add value in first loop on Temp to brake row if value has changed
        if (!temp) {
          temp = item.likelihood_score
        }

        // if value has change then add row
        if (temp !== item.likelihood_score) {
          temp = item.likelihood_score
          addToRow()
        }

        const result = data?.find((value) => value.risk_level_id === item.id)

        // push children on tr
        children.push(
          <td
            style={{
              background: item?.color_code || '',
              padding: '10px',
              margin: '10px',
              width: '100px',
              height: '100px',
              cursor: 'pointer',
              textAlign: 'center',
            }}
            cellPadding={1}
            className={selected === item.id || defaultValue === item.id ? 'box active' : 'box'}
            key={item.key}
            onClick={() => {
              onClick(item)
            }}
          >
            <Typography.Text>{`${item.group_name}(${result?.value || 0})`}</Typography.Text>
          </td>
        )

        // if it is an last value break row;
        if (length === index + 1) {
          addToRow()
        }
        return []
      })

      // Add label for row
      table.map((item, index) => {
        return item.props.children.unshift(
          <td style={{ textAlign: 'center' }} key={likelihoodLabel[index]} className="label-vertical">
            <Typography.Text>{likelihoodLabel[index]}</Typography.Text>
          </td>
        )
      })
      // Add label for col
      table.push(
        <tr key={'label-horizontal'}>
          <td key={'label-horizontal-span'} colSpan={2}></td>
          {riskLabel.map((text) => (
            <td style={{ textAlign: 'center' }} className="label-horizontal" key={text}>
              <Typography.Text>{text}</Typography.Text>
            </td>
          ))}
        </tr>
      )

      table.unshift(
        <tr key={'legend-vertical'}>
          <td className={'legend-vertical'} rowSpan={count + 1}>
            <Typography.Text>{t('Likelihood Level')}</Typography.Text>
          </td>
        </tr>
      )
      return table
    },
    [reportMatrixValue, selected, defaultValue, t]
  )

  const handleClick = (value) => {
    // let result = [...selected]
    // if(selected.includes(value.id)){
    //     result = result.filter(item => item !== value.id);
    // } else {
    //     result = [...selected,value.id]
    // }
    let result = undefined
    if (selected !== value.id) {
      result = value.id
    }
    setSelected(result)
    onChange(result)
  }
  return (
    <Styled className="risk-matrix-chart-component">
      <Spin spinning={loading}>
        {_.isEmpty(reportMatrixValue) ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <table className="risk-chart" id="risk-chart">
            <tbody>
              {row({
                data: dataSource,
                onClick: handleClick,
              })}
              <tr>
                <td className={'legend-vertical'} colSpan={2}></td>
                <td
                  style={{
                    textAlign: 'center',
                    paddingTop: '30px',
                    fontWeight: 'bold',
                  }}
                  colSpan={100}
                >
                  <Typography.Text>{t('Impact Level')}</Typography.Text>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </Spin>
    </Styled>
  )
}

export default RiskMatrixChart
